import { render } from "./RuiBadge.vue?vue&type=template&id=539b366b&scoped=true"
import script from "./RuiBadge.vue?vue&type=script&lang=ts"
export * from "./RuiBadge.vue?vue&type=script&lang=ts"

import "./RuiBadge.vue?vue&type=style&index=0&id=539b366b&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-539b366b"

export default script